module.exports = __webpack_public_path__ + "static/media/Badge_SvgAppConnecte_disabled.9ae93ea4.svg";